import React, { useMemo } from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

import InitiativeParticipants from 'containers/InitiativeParticipants';
import InitiativeCollaborators from 'containers/InitiativeCollaborators';
import InitiativeIndicators from 'containers/InitiativeIndicators';
import InitiativeTags from 'containers/InitiativeTags';
import InitiativeDocuments from 'containers/InitiativeDocuments';
import InitiativeImages from 'containers/InitiativeImages';
import When from '../cards/When';
import Organizer from '../cards/Organizer';
import Description from '../cards/Description';
import Categories from '../cards/Categories';
import TargetAudience from '../cards/TargetAudience';
import Address from '../cards/Address';
import Contact from '../cards/Contact';
import Groups from '../cards/Groups';
import FeedbackUrl from '../cards/FeedbackUrl';

import { useFeatureList } from 'components/FeatureSwitch';
import { usePermissionList } from 'components/PermissionSwitch';
import PendingCountBadge from 'components/PendingCountBadge';

import { Tabs, Row, Col } from 'antd';

const Collection = ({
  intl,
  push,
  slug,
  action,
  organization,
  initiative,
  admin_profile,
  taxonomies,
  requestInitiativeDetail,
  cancelInitiative,
  requestCollaboration,
  updateCollaboration,
  cancelCollaborationRequest,
  stopCollaboration,
  isOrganizer,
  isCollaborator,
  loading,
  loading_member_id,
  canEdit,
  location,
}) => {
  const t = intl.messages;
  const featureList = useFeatureList();
  const permissionList = usePermissionList();
  const activeKey = useMemo(() => {
    return location.pathname.split('/').splice(-1,1).toString()
  }, [ location.pathname ]);

  return (
    <Tabs
      className='initiativeTabs'
      defaultActiveKey="details"
      onChange={key => push(`/initiative/${slug}/${key}`)}
      activeKey={activeKey}
      renderTabBar={(props) =>
        <Row type="flex" className='actionTabs'>
          { props.panes.map((tab) => (
            !tab ? null :
            <Col
              className={'tab ' + (props.activeKey === tab.key ? 'active' : '')}
              onClick={() => props.onTabClick(tab.key)}>
                <span>{tab.props.tab}</span>
                <PendingCountBadge initiative={initiative} tab={tab} />
            </Col>
          ))}
        </Row>
    }>
      <Tabs.TabPane tab={ t.details } key="details">
        <Row type="flex" gutter={50} className='actionDetails'>
          <Col xs={24} md={18}>
            <Row>
              <Description {...initiative} />
            </Row>
            <Row>
              <Col lg={24} xl={11}>
                <Categories {...initiative} />
              </Col>
              <Col lg={24} xl={11}>
                <TargetAudience {...initiative} />
              </Col>
              <Col lg={24} xl={13}>
                <Groups taxonomies={taxonomies} {...initiative} />
              </Col>
            </Row>
          </Col>
          <Col xs={24} md={6}>
            <When {...initiative} showWorkingHours={!!(organization.config || {}).consider_working_hours} />
            <Address {...initiative} />
            <Contact {...initiative} />
            <Organizer {...initiative} />
            <FeedbackUrl {...initiative} />
            {
              !canEdit && (!initiative.tags || initiative.tags.length === 0)
              ? null
              : (
                <InitiativeTags
                  loading={loading}
                  initiative_slug={initiative.slug}
                  {...initiative}
                  canEdit={canEdit}
                />
              )
            }
          </Col>
        </Row>
      </Tabs.TabPane>
      { (!isOrganizer && !isCollaborator) || !permissionList.has('can_manage_participation') ? null :
        <Tabs.TabPane tab={ t.contributors} key="contributors">
          <InitiativeParticipants
            loading={loading_member_id}
            isCollectionInitiative
            {...initiative}
          />
        </Tabs.TabPane>
      }
      {
        !isOrganizer || (
          !initiative.collaborative &&
          (initiative.collaborators || []).length === 0
        ) ||
        !permissionList.has('can_manage_collaborations')
        ? null : (
          <Tabs.TabPane tab={ t.collaborators } key="collaborators">
            <InitiativeCollaborators loading={loading} {...initiative} />
          </Tabs.TabPane>
        )
      }
      { (isOrganizer || isCollaborator) && featureList.has('impact') &&
        <Tabs.TabPane tab={ t.indicators } key="indicators">
          <InitiativeIndicators
            initiative={initiative}
            organization={organization} />
        </Tabs.TabPane>
      }
      { (isCollaborator || isOrganizer) && !organization?.config?.hide_initiative_images &&
      <Tabs.TabPane tab={ t.initiative_images } key="images">
        <InitiativeImages
          canEdit={canEdit}
          initiative={initiative}
          organization={organization}
        />
      </Tabs.TabPane>
      }
      { (isCollaborator || isOrganizer) && !organization?.config?.hide_initiative_documents &&
      <Tabs.TabPane tab={ t.initiative_documents } key="documents">
        <InitiativeDocuments
          canEdit={canEdit}
          initiative={initiative}
          organization={organization}
        />
      </Tabs.TabPane>
      }
    </Tabs>
  )
}

export default injectIntl(withRouter(Collection));
